import axios from 'axios';
import React, { useState } from 'react';
import { Container, TextField, Button, Box, Typography, Paper, Snackbar, Alert } from '@mui/material';
import { API_URL, authHeaders } from '../api';

const AdminPanel = () => {
    const [team1, setTeam1] = useState('');
    const [team2, setTeam2] = useState('');
    const [datetime, setDatetime] = useState('');
    const [location, setLocation] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    const handleSnackbarOpen = () => {
        setSnackbarOpen(true);
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const matchData = {
            team1,
            team2,
            datetime,
            location
        };

        try {
            const response = await axios.post(`${API_URL}/api/matches`, matchData, { headers: authHeaders() });
            console.log('Match added successfully:', response.data);
            handleSnackbarOpen(); // Open the snackbar on success
            // Clear the form fields
            setTeam1('');
            setTeam2('');
            setDatetime('');
            setLocation('');
        } catch (error) {
            console.error('Error adding match:', error);
        }
    };

    return (
        <Container maxWidth="sm">
            <Paper elevation={3} style={{ padding: '20px', marginTop: '20px', background: 'transparent' }}>
                <Typography variant="h4" component="h1" gutterBottom>
                    Add a New Match
                </Typography>
                <form onSubmit={handleSubmit}>
                    <Box display="flex" flexDirection="column" gap="20px">
                        <TextField 
                            label="Team 1"
                            variant="outlined"
                            value={team1}
                            onChange={(e) => setTeam1(e.target.value)}
                            required
                        />
                        <TextField 
                            label="Team 2"
                            variant="outlined"
                            value={team2}
                            onChange={(e) => setTeam2(e.target.value)}
                            required
                        />
                        <TextField 
                            label="Date and Time"
                            type="datetime-local"
                            variant="outlined"
                            value={datetime}
                            onChange={(e) => setDatetime(e.target.value)}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            required
                        />
                        <TextField 
                            label="Location"
                            variant="outlined"
                            value={location}
                            onChange={(e) => setLocation(e.target.value)}
                            required
                        />
                        <Button type="submit" variant="contained" color="primary" sx={{ padding: '10px' }}>
                            Add Match
                        </Button>
                    </Box>
                </form>
                <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
                    <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
                        Match added successfully!
                    </Alert>
                </Snackbar>
            </Paper>
        </Container>
    );
};

export default AdminPanel;
